import React, { useState, useEffect, useContext } from "react"
import PropTypes from "prop-types"
import { useTransitionState } from "gatsby-plugin-transition-link/hooks"
import { useSpring, animated, config } from "react-spring"

import { JungContext, useAudioInit } from "../../plugins/gatsby-plugin-jung-wrapper/JungContext"

import AppHeader from "./AppHeader"

import "./reset.scss"
import "./AppLayout.scss"

const colorLM1Elements = "255, 255, 255"
const colorLM1Text = "255, 255, 255"

const AppLayout = ({ location, inMenu, menuOpenedFrom, children, jungState = "blur" }) => {
    let jungContext = useContext(JungContext)
    let audioInit = useAudioInit()
    let [mounted, setMounted] = useState(false)
    let { mount } = useTransitionState()
    let style = useSpring({
        opacity: mounted ? 1 : 0,
        config: { ...config.slow, duration: 850 },
    })
    useEffect(() => {
        setMounted(mount)
    }, [mount])
    useEffect(() => jungContext.setState(jungState), [jungState])

    return (
        <div
            className="app"
            style={{
                "--colorElements": colorLM1Elements,
                "--colorText": colorLM1Text,
            }}
            onClick={audioInit}
        >
            <AppHeader location={location} inMenu={inMenu} menuOpenedFrom={menuOpenedFrom} />
            <main className="appMain">
                <div className="appContent">
                    <animated.div style={style}>{children}</animated.div>
                </div>
            </main>
        </div>
    )
}

AppLayout.propTypes = {
    children: PropTypes.node.isRequired,
}

export default AppLayout
